jQuery(document).ready(function ($) {
  $('.stories-blog-carousel').owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 2,
        autoWidth: true
      },
      600: {
        items: 3
      },
      1000: {
        items: 3
      }
    }
  });
});

jQuery(document).ready(function ($) {
  const $dropdownButton = $(".dropdown-button");
  const $dropdownMenu = $(".dropdown-menu");

  // Toggle dropdown visibility on button click
  $dropdownButton.click(function (event) {
    $dropdownMenu.toggle();
    event.stopPropagation(); // Prevent event from bubbling to `document`
  });

  // Hide dropdown when clicking outside
  $(document).click(function (event) {
    if (!$dropdownButton.is(event.target) && !$dropdownMenu.has(event.target).length) {
      $dropdownMenu.hide();
    }
  });

  // Selecting an item
  $(".dropdown-menu li").click(function () {
    $dropdownButton.text($(this).text()); // Update button text
    $dropdownMenu.hide(); // Hide menu after selection
  });
});

document.getElementById('water-report-form').addEventListener('submit', function(e) {
    e.preventDefault(); // Prevent default form submission
  
    //const name = document.getElementById('name').value;
    const zipCode = document.getElementById('zip-code').value;
    const user_email = document.getElementById('email').value;
    const loader = document.querySelector('.loading');

    localStorage.setItem('zipCode', zipCode);
localStorage.setItem('user_email', user_email);
    if (!email) {
      alert('Please enter your email address.');
      return; 
    }
  
    // const formData = new FormData();
    // formData.append('zip-code', zipCode);
    // formData.append('email', user_email);
  
    // loader.classList.add('active');
  
    // // Send data to the Afina API endpoint
    // fetch('https://api.afina.com/liveapi/klaviyo_w_reportapi.php', {
    //   method: 'POST',
    //   body: formData
    // })
    // .then(response => response.json())
    // .then(data => {
    //   if (data.error) {
    //     alert(data.error);
    //   } else {
    //     console.log('Success:', data);

//8th april top comment


  
          fetch(`https://api.afina.com/liveapi/zip_codepdf.php?zip_code=${zipCode}`)


.then(response => response.text()) // First, get response as text
                    .then(text => {
console.log('Raw API Response:', text);
if (!text.trim()) {
            console.error('Empty response from API');
            alert('Error: No response from the server. Please try again later.');
            return;
        }

                        try {
                            const data = JSON.parse(text); // Attempt to parse JSON
                            console.log('Second API data:', data);

                            if (data.status !== 'False') {
                               // window.location.href = 'https://afina.com/pages/water-result';
                                window.location.href = `https://afina.com/pages/water-result?zip_code=${encodeURIComponent(zipCode)}`;
                            } else {
                                const errorMessage = data.message || 'Please enter a valid zip code';
                                const zipCodeInput = document.getElementById('zip-code');
                                localStorage.removeItem('zipCode');
console.log(data);

                                zipCodeInput.placeholder = errorMessage;
                                zipCodeInput.value = '';
                            }
                        } catch (error) {
                            console.error('Invalid JSON response:', text);
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching second API:', error);
                    });
           // }
        //})
        // .catch(error => {
        //     alert('There was an error submitting the form. Please check the console for details.');
        //     console.error('Error:', error);
        // });
});

